import { toast } from "react-toastify";

const auth = localStorage.getItem("tourism_admin");
const initialState = {
    auth: auth ? JSON.parse(auth) : {},
    isAuthenticated: auth ? true : false,
    loading: false,
    errors: {}
};

const AuthReducer = (state = initialState, action) => {
    switch (action.type) {
        case "LOGIN_PENDING":
            return { ...state, loading: true };
        case "LOGIN_FULFILLED":
            localStorage.setItem("tourism_admin", JSON.stringify(action.payload));
            return { ...state, loading: false, auth: action.payload, isAuthenticated: true };
        case "LOGIN_FAILED":
            toast.error(action.payload?.message);
            return { ...state, loading: false, errors: action.payload };
        case "LOG_OUT_FULFILLED":
            localStorage.removeItem("tourism_admin");
            return { ...state, auth: {}, isAuthenticated: false };
        default:
            return state;
    }
};

export default AuthReducer;
